import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=12ffd0d2"
var script = {}
import style0 from "./navigation.vue?vue&type=style&index=0&id=12ffd0d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports